import React from 'react';
import { View, Pressable } from 'react-native';
import Icon from '../../../../../Icon';

import defaultStyles from './VolumeControls.jss';

const MAX_VOLUME_BARS = 10;

interface VolumeControlsProps {
    onVolumeDecreasePress?: () => Promise<void>;
    onVolumeRaisePress?: () => Promise<void>;
    volume: number;
    setVolumeByValue: (val: number) => Promise<void>;
}

const VolumeControls = ({
    onVolumeDecreasePress,
    onVolumeRaisePress,
    volume,
    setVolumeByValue
}: VolumeControlsProps): React.ReactElement => {
    const { volumeBar, volumeBarContainer, filledVolumeBar } = defaultStyles;

    return (
        <View style={defaultStyles.container}>
            <Icon name="volume_mute" onPress={onVolumeDecreasePress} testID="volume_mute_button" />
            <View style={defaultStyles.volumeBarsContainer}>
                {new Array(MAX_VOLUME_BARS).fill(null).map((_, index) => {
                    const isActive = index < Math.floor(volume * 10);
                    return (
                        <Pressable
                            testID="volume_bar_button"
                            key={`volume-bar-${index}`} // eslint-disable-line react/no-array-index-key
                            style={volumeBarContainer}
                            onPress={async () => await setVolumeByValue((index + 1) / 10)}
                        >
                            <View style={[volumeBar, isActive && filledVolumeBar]} />
                        </Pressable>
                    );
                })}
            </View>
            <Icon name="volume" onPress={onVolumeRaisePress} testID="volume_up_button" />
        </View>
    );
};

export default VolumeControls;
